import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Button from '../components/ui/Button';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Компонент FaqPage - страница с часто задаваемыми вопросами
 */
const FaqPage = () => {
  const { darkMode, toggleDarkMode } = useTheme();
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Что такое Gensio и зачем он нужен?',
      answer: 'Gensio — это бесплатная онлайн-платформа с более чем 300 инструментами для расчетов, конвертации, генерации и других задач. Она помогает быстро получать результаты прямо в браузере без установки ПО.'
    },
    {
      question: 'Нужно ли регистрироваться, чтобы пользоваться инструментами?',
      answer: 'Нет, регистрация не требуется. Все инструменты доступны бесплатно и без ограничений.'
    },
    {
      question: 'Как добавляются новые инструменты на платформу?',
      answer: 'Наша команда постоянно работает над разработкой и внедрением новых инструментов. Вы также можете предложить идею через форму обратной связи.'
    },
    {
      question: 'Как связаться с поддержкой?',
      answer: 'Вы можете отправить сообщение через раздел "Контакты" в футере сайта или написать нам на email info@gensio.ru'
    },
    {
      question: 'Можно ли использовать Gensio на мобильных устройствах?',
      answer: 'Да, платформа полностью адаптивна и работает на любых современных смартфонах и планшетах.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-200">
      {/* Фоновый узор */}
      <div className="fixed inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] dark:bg-[radial-gradient(#1f2937_1px,transparent_1px)] [background-size:20px_20px] opacity-20 pointer-events-none"></div>

      {/* Навигационная панель */}
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

      {/* Основное содержимое */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <section className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Часто задаваемые вопросы</h1>
          <p className="text-lg text-gray-700 dark:text-gray-300">
            Здесь вы найдёте ответы на самые популярные вопросы о платформе Gensio.
          </p>
        </section>

        <section className="space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-100 dark:border-gray-700"
            >
              <button
                className="w-full flex justify-between items-center"
                onClick={() => toggleFAQ(idx)}
              >
                <span className="text-left text-lg font-medium">{faq.question}</span>
                {openIndex === idx ? <ChevronUp /> : <ChevronDown />}
              </button>
              {openIndex === idx && (
                <div className="mt-4 text-gray-600 dark:text-gray-400">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </section>

        <section className="text-center mt-16">
          <h2 className="text-2xl font-semibold mb-4">Не нашли ответа?</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-6">
            Если у вас остались вопросы, свяжитесь с нами, и мы будем рады помочь.
          </p>
          <Button
            primary
            className="px-8 py-4 text-lg"
            onClick={() => navigate('/contact')}
          >
            Контакты
          </Button>
        </section>
      </main>

      {/* Футер */}
      <Footer />
    </div>
  );
};

export default FaqPage;
